import maCameraComponent from '@/components/cameraComponent'

export default {
  name: 'cameraWithSteps',

  props: {
    steps: {
      required: false,
      type: Number,
      default: 3
    },
    groups: {
      required: false,
      type: Number,
      default: 1
    },
    title: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      totalNumber: this.steps * this.groups,
      finish: false
    }
  },

  components: {
    maCameraComponent
  },

  computed: {
    stepsArray() {
      // crea un array de longitud `steps` y lo rellena con los índices del 0 al `steps - 1`
      return Array.from({ length: this.steps }, (_, index) => index)
    }
  },

  methods: {
    resetSteps() {
      const steps = this.$refs.stepper.children

      for (const step of steps) {
        step.classList.remove('camera__completed')
      }
    },
    handlePhotos(photos) {
      if (this.isFinish) return

      const steps = this.$refs.stepper.children
      const photoNumber = photos.length
      const photoIndex = (photoNumber % this.steps) - 1

      this.$emit('photo')

      if (photoIndex === -1) {
        this.resetSteps()
      } else {
        steps[photoIndex].classList.add('camera__completed')
      }

      if (photos.length === this.steps * this.groups) {
        this.isFinish = true
        this.$emit('photosArray', photos)
      }
    },

    takePhoto() {
      setTimeout(() => {
        if (this.$refs.camera) {
          this.$refs.camera.takePhoto()
        }
      }, 2000)
    },

    switchCamera() {
      this.$refs.camera.switchCamera()
    },

    resetInputValue() {
      if (this.$refs.gallery) {
        this.$refs.gallery.value = null
      }
    },

    async handleChangeInput(event) {
      if (event.target.files.length === 0) return

      const maxValueFilesize = 6000000
      const acceptedFileExtensions = ['image/jpg', 'image/jpeg', 'image/png']

      const file = event.target.files[0]
      const fileSize = file.size
      const fileExtension = file.type

      const isFileSizeValid = fileSize <= maxValueFilesize
      const isFileExtensionValid =
        acceptedFileExtensions.includes(fileExtension)

      if (isFileSizeValid && isFileExtensionValid) {
        await this.$refs.camera.addPhotoFromGallery(file)
      }

      this.resetInputValue()
    }
  }
}
